import { AssertIdRequest, CommonResponse, LotDetailsResModel, RejectionResponseModel, RejectionsDto, RejectionsResponseModel, SoakingTubResponseModel } from '@gtpl/shared-models/production-management';

import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { SoakingRequestDto } from './dto/soaking-request.dto';
import { SoakingService } from './soaking.service';

@ApiTags('Soaking Tub')
@Controller('soaking-tub')
export class SoakingController {
    constructor(
        private soakingService: SoakingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }

    @Post('/createSoaking')
    async createSoaking(@Body() inputReq: SoakingRequestDto): Promise<SoakingTubResponseModel> {
        try {
            return await this.soakingService.createSoaking(inputReq,false,undefined);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(SoakingTubResponseModel, error);
        }
    }
    @Post('/getMachinedetails')
    async getMachinedetails(@Body() req:AssertIdRequest): Promise<CommonResponse> {
        try {
            return await this.soakingService.getMachinedetails(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

}